export const COMPANY = {
  name: "Udat Marine Sdn Bhd",
  regNo: "JM 0340759-U",
  address: "P75 Pekan Pengerang, 81600 Pengerang, Johor Darul Takzim, Malaysia",
  phoneOffice: "+607 8251272",
  phoneDuty: "+6017-7529304",
  fax: "+607 8251002",
  emails: [
    { dept: "General Enquiries", email: "udatmarine@gmail.com" },
    { dept: "Accounts", email: "udatmarineacc@gmail.com" },
    { dept: "Crewing & Husbandry", email: "udatcrewing@gmail.com" },
  ],
  facebook: "https://web.facebook.com/udatmarinesb/",
};

export const NAV_LINKS = [
  { label: "Who We Are", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Salvage", href: "#salvage" },
  { label: "Projects", href: "#projects" },
  { label: "Fleet", href: "#assets" },
  { label: "Contact", href: "#contact" },
];

export const HERO_LINES = [
  { text: "THE SEA", accent: false },
  { text: "DOESN'T WAIT.", accent: false },
  { text: "NEITHER DO WE.", accent: true },
];

export const STATS = [
  { value: "20+", label: "Years in operation" },
  { value: "100%", label: "Bumiputera-owned" },
  { value: "24/7", label: "Deployment & emergency response" },
  { value: "E+W", label: "East & West Johor shipping lanes" },
];

export const MARQUEE_ITEMS = [
  "Salvage & Response",
  "Port Husbandry",
  "Wreck Removal",
  "Heavy Lifting",
  "Fresh Water Supply",
  "Crew Transfer",
  "Ship Chandling",
  "24/7 Deployment",
];

export const SERVICES = [
  {
    index: "01",
    title: "Shipping Agency",
    desc: "Complete port husbandry & government regulatory management — vessel declarations, shipping clearance, crew changes, crew logistics and victualling across East and West Johor, including expert handling of detained vessel cases.",
    tags: ["Port Husbandry", "Crew Change", "Detained Cases"],
    flagship: false,
  },
  {
    index: "02",
    title: "Boat Services",
    desc: "Launch boats, speed boats, cargo boats, landing craft and garbage collection boats — deployed 24/7 from Tanjung Pengelih Ferry Terminal for agents, surveyors, owners and technical crews.",
    tags: ["Launch", "Cargo", "Landing Craft"],
    flagship: false,
  },
  {
    index: "03",
    title: "Fresh Water Supply",
    desc: "Certified fresh water delivered by our dedicated water barges to ships within and outside the Johor Port Limit — timely, high-quality supply to keep your vessel running.",
    tags: ["Water Barges", "Inside & Outside JPL"],
    flagship: false,
  },
  {
    index: "04",
    title: "Provision Supplies",
    desc: "Licensed ship chandler supplying fresh produce, meats, dry goods and bonded stores — delivered promptly with meticulous service, wherever your crew is berthed.",
    tags: ["Ship Chandler", "Bonded Stores"],
    flagship: false,
  },
  {
    index: "05",
    title: "Crew Transportation",
    desc: "Our own in-house fleet, from regular cars to spacious MPVs, makes every crew change seamless — comfortable, timely pickups and drop-offs across Pengerang.",
    tags: ["In-House Fleet", "Cars to MPVs"],
    flagship: false,
  },
  {
    index: "06",
    title: "Heavy Lifting & Wreck Salvage",
    desc: "Our flagship division: heavy lifting, wreck removal, refloating, emergency towing and underwater hull surveys — executed with partners across the Asian region.",
    tags: ["Wreck Removal", "Refloating", "Towing"],
    flagship: true,
  },
  {
    index: "07",
    title: "Coastal Engineering",
    desc: "Consortium-led coastal reclamation, marine dredging support and shoreline civil works — including execution at Danga Bay.",
    tags: ["Reclamation", "Dredging"],
    flagship: false,
  },
  {
    index: "08",
    title: "Fuel & Technical Supply",
    desc: "Marine Gas Oil agency services supporting licensed bunker suppliers across East and West Johor, Port Klang and Penang waters — plus engine spares and technical equipment sourced through direct Singapore pipelines.",
    tags: ["MGO Agency", "Engine Spares"],
    flagship: false,
  },
];

export const PROJECTS = [
  {
    index: "P.01",
    title: "KD Pendekar — Navy Warship Refloated",
    desc: "In a defining salvage operation, we refloated the Royal Malaysian Navy's KD Pendekar — a 45-year-old warship raised from the seabed two nautical miles off Tanjung Penyusop, Johor, in October 2024.",
    news_url:
      "https://www.astroawani.com/berita-malaysia/kd-pendekar-berjaya-diapung-semula-tldm-491616",
    news_source: "Astro Awani",
    gallery: [
      "images/unsplash-ocean.jpg",
      "images/salvage-1.jpg",
      "images/deck-cranes.jpg",
    ],
    wide: true,
  },
  {
    index: "P.02",
    title: "East Port Limit & Off Port Limit Rescue & Salvage",
    desc: "Complex offshore rescue and salvage execution across demanding international maritime corridors.",
    gallery: [
      "images/proj-tug.jpg",
      "images/tug-aerial.jpg",
      "images/bridge-night.jpg",
    ],
    wide: false,
  },
  {
    index: "P.03",
    title: "Danga Bay Land Reclamation",
    desc: "Consortium-led marine earthworks and coastal reclamation for complex shoreline development.",
    gallery: [
      "images/proj-harbor.jpg",
      "images/proj-redship.jpg",
      "images/unsplash-cargo.jpg",
    ],
    wide: false,
  },
];

export const ASSETS = [
  {
    title: "Marine Response Vessel",
    desc: "Specialized vessels supporting salvage operations, emergency towing, offshore rescue, fresh water delivery and marine fieldwork.",
    img: "images/vessel-1.jpg",
    specs: [
      { k: "Type", v: "Response Vessel" },
      { k: "Role", v: "Salvage · Towing · Fieldwork" },
      { k: "Status", v: "Active" },
    ],
  },
  {
    title: "Crew Transfer Launch",
    desc: "Prompt offshore transport from Tanjung Pengelih Ferry Terminal for shipping agents, surveyors, vessel owners and technical crews.",
    img: "images/unsplash-crewboat.jpg",
    specs: [
      { k: "Type", v: "Launch / Pilot Boat" },
      { k: "Area", v: "Pasir Gudang · Pengerang" },
      { k: "Status", v: "Active" },
    ],
  },
  {
    title: "Salvage Recovery Equipment",
    desc: "Heavy-lifting, wreck-removal, refloating, emergency response and underwater survey capability for demanding marine situations.",
    img: "images/salvage-1.jpg",
    specs: [
      { k: "Type", v: "Heavy Lift & Wreck Spread" },
      { k: "Status", v: "Mobilised 24/7" },
    ],
  },
];

export const WHY_REASONS = [
  {
    icon: "anchor",
    title: "24/7 From Tanjung Pengelih",
    desc: "Our own terminal base at Pengerang — boats, barges and crews mobilising around the clock, day and night.",
  },
  {
    icon: "badge",
    title: "Licensed & Registered",
    desc: "Registered with the Royal Malaysian Customs Department, Immigration Department, Marine Department and Johor Port Berhad.",
  },
  {
    icon: "ship",
    title: "Our Own Fleet & Equipment",
    desc: "Launch boats, landing craft, water barges and crew transport owned in-house — no middlemen, no waiting.",
  },
  {
    icon: "lifbuoy",
    title: "Proven in Salvage",
    desc: "From a sunken navy warship off Johor to PETRONAS heavy lifts — a track record earned on real operations.",
  },
];

export const PRESS_COVERAGE = [
  {
    source: "Astro Awani",
    date: "14 Oct 2024",
    headline: "KD Pendekar berjaya diapung semula — TLDM",
    url: "https://www.astroawani.com/berita-malaysia/kd-pendekar-berjaya-diapung-semula-tldm-491616",
  },
  {
    source: "The Star",
    date: "13 Oct 2024",
    headline: "Navy successfully salvages sunken vessel KD Pendekar",
    url: "https://www.thestar.com.my/news/nation/2024/10/13/navy-successfully-salvages-sunken-vessel-kd-pendekar",
  },
  {
    source: "Malay Mail",
    date: "14 Oct 2024",
    headline: "Navy refloats KD Pendekar amid salvage challenges",
    url: "https://www.malaymail.com/news/malaysia/2024/10/14/navy-refloats-kd-pendekar-amid-salvage-challenges-that-killed-one-diver-no-explosives-found-at-wreck-site/153541",
  },
  {
    source: "Defence Security Asia",
    date: "Oct 2024",
    headline: "KD Pendekar successfully salvaged by the Royal Malaysian Navy",
    url: "https://defencesecurityasia.com/en/kd-pendekar-successfully-salvaged-royal-malaysian-navy/",
  },
  {
    source: "Malaysian Defence",
    date: "Oct 2024",
    headline: "KD Pendekar recovered",
    url: "https://www.malaysiandefence.com/kd-pendekar-recovered/",
  },
];

export const SERVICE_OPTIONS = [
  ...SERVICES.map((s) => s.title),
  "Other / General Enquiry",
];
